import * as yup from 'yup';

const { object, boolean } = yup;

export const updateUserRolesSchema = object({
  isUserAdmin: boolean().required(),
  isStockAdmin: boolean().required(),
  isOrderAdmin: boolean().required(),
  isLocationAdmin: boolean().required(),
});

export type UpdateUserRolesFormData = yup.InferType<
  typeof updateUserRolesSchema
>;
